export default {
    industry_1: 'Maritime',
    industry_2: 'Education',
    industry_10000: 'All',
};
